module.exports = __webpack_public_path__ + "static/img/no_list.3d017c22.png";